import axios from '../axiosConfig'
import { getEnv } from '@utils/env'
import {
  getMockReportByPage,
  isReportsMockDataEnabled,
} from '@assets/mockdata/Reports/reportsByPage.mockdata'

const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_REPORTS')

interface ApiResponse<T> {
  statusCode: number
  message: string
  data: T
}

export interface ReportMeta {
  hasData: boolean
  sourceRowCount: number
  generatedAt: string
}

export type ReportWithMeta = { reportMeta: ReportMeta }

export type ReportRequestOptions = {
  signal?: AbortSignal
  refresh?: boolean
}

/** Shared report query params accepted by GET /api/v1/reports/by-page */
export type ByPageReportQueryParams = {
  clinicId: string
  periodPreset: string
  referenceDate?: string
  providerId?: string
  startDate?: string
  endDate?: string
  snapshotDate?: string
  snapshotHour?: number
}

export const getReportByPage = <T>(
  pageId: string,
  params: ByPageReportQueryParams,
  options?: ReportRequestOptions,
): Promise<T & ReportWithMeta> => {
  if (isReportsMockDataEnabled()) {
    const mockReport = getMockReportByPage(pageId)
    if (mockReport) {
      return Promise.resolve({
        ...(mockReport as T),
        reportMeta: {
          hasData: true,
          sourceRowCount: 0,
          generatedAt: new Date().toISOString(),
        },
      } as T & ReportWithMeta)
    }
  }

  return axios
    .get<ApiResponse<T & ReportWithMeta>>(
      `${BUSINESS_LAYER_API}/api/v1/reports/by-page`,
      {
        params: {
          page_id: pageId,
          ...params,
          ...(options?.refresh ? { refresh: true } : {}),
        },
        signal: options?.signal,
      },
    )
    .then((response) => response.data.data)
}
